/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon'; // Outline

const FilePdfOutline = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M4.125 12.375v-8.25a.75.75 0 0 1 .75-.75h9m0 0 5.25 5.25m-5.25-5.25v5.25h5.25m0 0v3.75m-15 6.75h1.5a1.499 1.499 0 0 0 1.06-2.56c-.28-.28-.66-.44-1.06-.44h-1.5v4.5m15.75-4.5h-2.63v4.5m2.26-1.87h-2.26m-5.62 1.87c.6 0 1.17-.24 1.59-.66a2.248 2.248 0 0 0-1.59-3.84h-1.31v4.5h1.31z"
})); // Fill


const FilePdfFill = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M5.625 15.375h-1.5a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-.75h.75c.6 0 1.17-.24 1.59-.66a2.248 2.248 0 0 0-1.59-3.84zm0 3h-.75v-1.5h.75a.75.75 0 0 1 0 1.5zm12.38-1.5v1.13h1.5c.19 0 .38.07.53.21.14.15.21.34.21.54 0 .19-.07.38-.21.53-.15.14-.34.22-.53.22h-1.5v1.12c0 .2-.08.39-.22.53a.79.79 0 0 1-.54.22c-.19 0-.38-.08-.53-.22a.74.74 0 0 1-.21-.53v-4.5c0-.2.07-.39.21-.53.15-.14.34-.22.53-.22h2.63a.75.75 0 0 1 0 1.5h-1.87zm-6.38-1.5h-1.31a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 .75.75h1.31c.8 0 1.56-.32 2.12-.88a2.997 2.997 0 0 0-2.12-5.12zm0 4.5h-.56v-3h.56a1.499 1.499 0 0 1 1.06 2.56c-.28.28-.66.44-1.06.44zm-7.5-6.75h15a.75.75 0 0 0 .75-.75v-3.75c0-.2-.08-.39-.22-.53l-5.25-5.25a.75.75 0 0 0-.53-.22h-9a1.499 1.499 0 0 0-1.5 1.5v8.25a.75.75 0 0 0 .75.75zm9.75-8.62 4.13 4.12h-4.13v-4.12z"
})); // DuoTone


const FilePdfDuotone = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M13.875 3.375v5.25h5.25l-5.25-5.25z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M4.125 12.375v-8.25a.75.75 0 0 1 .75-.75h9m0 0 5.25 5.25m-5.25-5.25v5.25h5.25m0 0v3.75m-15 6.75h1.5a1.499 1.499 0 0 0 1.06-2.56c-.28-.28-.66-.44-1.06-.44h-1.5v4.5m15.75-4.5h-2.63v4.5m2.26-1.87h-2.26m-5.62 1.87c.6 0 1.17-.24 1.59-.66a2.248 2.248 0 0 0-1.59-3.84h-1.31v4.5h1.31z"
}));
/**
  Icon FilePdfIcon in office group
*/


export const FilePdfIcon = createIcon('FilePdfIcon', 'file-pdf', 'office', FilePdfOutline, FilePdfFill, FilePdfDuotone, "0 0 24 24");